import useMapActions from "@/hooks/useMapActions";
import { EmitStores } from "@/libs/SocketService";

type SaveStore =
	| EmitStores.BUILDINGS_STORAGE
	| EmitStores.MAP
	| EmitStores.UPGRADES;

/** Matches {@link EmitStores} string values. */
type SaveStoresPayload = {
	stores?: ReadonlyArray<EmitStores>;
};

type EmitSaveRequest = (payload?: SaveStoresPayload) => Promise<void>;

let emitSaveRequest: EmitSaveRequest | null = null;

/** Wired from {@link useSocketService} when the socket singleton is created */
export function registerEventEndTeardownSave(fn: EmitSaveRequest): void {
	emitSaveRequest = fn;
}

/**
 * Persists local teardown (zeroed buildingsStorage) when stores are dirty.
 */
export async function persistEventCleanup(): Promise<void> {
	if (!emitSaveRequest) return;

	const storesToSave: Array<SaveStore> = [];

	const addIfPending = (condition: boolean, store: SaveStore): void => {
		if (condition) storesToSave.push(store);
	};

	addIfPending(true, EmitStores.BUILDINGS_STORAGE);
	addIfPending(!useMapActions().isActionQueueEmpty(), EmitStores.MAP);

	if (!storesToSave.length) return;

	try {
		await emitSaveRequest({ stores: storesToSave });
	} catch (error) {
		console.error("[persistEventEndTeardownAfterClear]", error);
	}
}

/** Persists zeroed event upgrade levels after local reset (new event or calendar end). */
export async function persistEventUpgradeReset(): Promise<void> {
	if (!emitSaveRequest) return;

	try {
		await emitSaveRequest({ stores: [EmitStores.UPGRADES] });
	} catch (error) {
		console.error("[persistEventUpgradeReset]", error);
	}
}
